<p-confirmDialog header="Atenção"
  icon="pi pi-exclamation-triangle">
</p-confirmDialog>
<p-toast></p-toast>
<div class="p-field p-col-12 p-md-12 p-lg-12"
  *ngIf="_loading">
  <p-progressBar mode="indeterminate"
    [style]="{'height': '6px'}"></p-progressBar>
</div>
<habil-grupo *ngIf="!loadingModules && !_loading">
  <p-scrollPanel [style]="{width: '100%', height: 'calc(100svh - 190px)'}">
    <p-accordion>
      <p-accordionTab header="Dados Básicos"
        [selected]="true">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-lg-9">
            <habil-label name="txtNome"
              label="Nome">
              <input [readonly]="_readonly"
                type="text"
                name="txtNome"
                pInputText
                [(ngModel)]="obj.nome" />
            </habil-label>
          </div>
          <div class="p-field p-col-12 p-lg-3">
            <habil-label name="cbSoftware"
              label="Software">
              <p-dropdown [readonly]="_readonly"
                appendTo="body"
                [options]="softwares"
                (onChange)="onChangeSoftware()"
                [(ngModel)]="obj.software"
                optionLabel="label"
                optionValue="value"></p-dropdown>
            </habil-label>
          </div>
          <div class="p-field p-col-12 p-lg-5">
            <habil-label name="liberarDias"
              label="Dias primeiro vencimento">
              <p-inputNumber [readonly]="_readonly"
                [(ngModel)]="obj.liberarDias"
                inputId="liberarDias">
              </p-inputNumber>
            </habil-label>
          </div>
          <div class="p-field p-col-12 p-lg-7">
            <habil-label name="cbModulo"
              label="Primeiro módulo">
              <p-dropdown [readonly]="_readonly"
                appendTo="body"
                [options]="modules"
                [(ngModel)]="obj.idModuloPrimeiro"
                optionLabel="nomeProduto"
                optionValue="id"></p-dropdown>
            </habil-label>
          </div>
          <div class="p-field p-col-5">
            <habil-label name="searchClass"
              label="Classificação">
              <habil-autocomplete-edit [service]="classificacaoService"
                [(ngModel)]="obj.classificacao"
                [readonly]="_readonly"
                name="searchClass"
                field="descricao"
                dataKey="id">
              </habil-autocomplete-edit>
            </habil-label>
          </div>
          <div class="p-col p-col-align-center">
            <p-checkbox [binary]="true"
              [readonly]="_readonly"
              [(ngModel)]="obj.padrao"
              label="Ciclo de vida padrão para o software"></p-checkbox>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
    <br>
    <p-accordion>
      <p-accordionTab header="Após o primeiro vencimento, seguir o ciclo:"
        [selected]="true">
        <button pButton
          (click)="adicionarItem()"
          label="Adicionar"
          style="width: 180px;"
          icon="pi pi-plus"></button>
        <ng-container *ngFor="let i of obj.itens">
          <div style="height: 50px;"></div>
          <div class="p-grid p-fluid">
            <div class="p-col-fixed p-col-align-end"
              style="font-size: 16px; padding-bottom: 15px; width: 30px;">
              {{i.idInterno}}.
            </div>
            <div class="p-col-12 p-lg-3">
              <habil-label name="liberarDias"
                label="Liberar mais (dias)">
                <p-inputNumber [readonly]="_readonly"
                  [(ngModel)]="i.liberarDias"
                  inputId="liberarDias">
                </p-inputNumber>
              </habil-label>
            </div>
            <div class=" p-col">
              <habil-label name="cbModulo"
                label="Novo módulo">
                <p-dropdown [readonly]="_readonly"
                  appendTo="body"
                  [options]="modules"
                  [(ngModel)]="i.idModuloNovo"
                  optionLabel="nomeProduto"
                  optionValue="id"></p-dropdown>
              </habil-label>
            </div>
            <div class="p-col-fixed p-col-align-end">
              <button pButton
                label="Excluir"
                icon="pi pi-trash"
                class="p-button-text"
                (click)="apagarItem(i)"></button>
            </div>
          </div>
        </ng-container>
      </p-accordionTab>
    </p-accordion>
  </p-scrollPanel>
</habil-grupo>
<br>
<habil-botoes-cadastro (onError)="onErrorHandled()"
  [obj]="getObject.bind(this)"
  [dialog]="_isDialog"
  (onSaved)="onSave($event)"
  (onClosed)="onCancel()"
  [service]="service"
  [readonly]="_readonly"
  [validate]="doValidate.bind(this)"
  [doBeforeSave]="doBeforeSave.bind(this)"
  (onSaveAndNew)="onSaveAndNew($event)">
</habil-botoes-cadastro>